import UnavailableLocationModal from './UnavailableLocationModal';

export default UnavailableLocationModal;
